import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensBrandsList from './List/ScreensBrandsList';
import ScreensBrandsForm from './Form/ScreensBrandsForm';

function ScreensBrands() {
  return (
    <Routes>
      <Route
        path="/list"
        element={
          <RoutePrivate
            element={ScreensBrandsList}
            requiredPermission="brands.update"
          />
        }
      />
      <Route
        path="/create"
        element={
          <RoutePrivate
            element={ScreensBrandsForm}
            requiredPermission="brands.create"
          />
        }
      />
      <Route
        path="/:id/edit"
        element={
          <RoutePrivate
            element={ScreensBrandsForm}
            requiredPermission="brands.update"
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/brands/list" />} />
    </Routes>
  );
}

export default ScreensBrands;
